import _ from 'underscore';
import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import RolloutHelper from "models/helper/FeatureRolloutHelper";
import { createRoot } from "react-dom/client";
import AnalysisWizardContent from '../../components/deepcut/components/AnalysisWizardContent.jsx';
import ConfigProvider from "../../components/common/ConfigProvider";
import ti18n from "i18n!nls/Sequenceri18n";

const Rollout = RolloutHelper.getInstance();

const DeepCutPopupView = OptionPopupView.extend({

    "pageName": "DeepCut Analysis",

    initialize: function(options) {
        const viewOptions = {};

        const contentView = {};
        this._transcriptText = options.transcriptText;
        this._transcriptId = options.transcriptId;
        this._projectId = options.projectId;
        this._onAnalysisComplete = options.onAnalysisComplete;
        this._onEditingPlanApplied = options.onEditingPlanApplied;
        this._onWizardClosed = options.onWizardClosed;
        this._isEditLikeMeMode = !!options.isEditLikeMeMode;
        
        this.deepCutContainer$el = $('<div class="deepcut_analysis_content"></div>');
        this.deepCutContainer$el.css({
            "width": "100%",
            "padding": "16px"
        });
        contentView.$el = this.deepCutContainer$el;
        viewOptions.contentView = contentView;
        viewOptions.contentPosition = "text-not-white";
        viewOptions.addContentAfterEnhancement = true;
        viewOptions.displayTitle = false;
        viewOptions.titleToDisplay = window.getI18n(ti18n, "DEEPCUT_ANALYSIS_TITLE") || "Conversation Analysis";

        viewOptions.id = "DeepCutAnalysisPopup";
        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    afterRendering: function() {
        // Any additional setup after rendering
    },

    onPopupClosed: function() {
        if (this._deepCutWidgetRoot) {
            this._deepCutWidgetRoot.unmount();
            this._deepCutWidgetRoot = null;
        }
    }, 

    onAnalysisComplete: function(analysisResults) {
        this.trigger('analysisComplete', analysisResults);
        if (this._onAnalysisComplete) {
            this._onAnalysisComplete(analysisResults);
        }
    },

    onEditingPlanApplied: function(editingPlan) {
        this.trigger('editingPlanApplied', editingPlan);
        if (this._onEditingPlanApplied) {
            this._onEditingPlanApplied(editingPlan);
        }
        // Close the popup after applying the editing plan
        this.close();
    },

    onWizardClosed: function() {
        this.trigger('wizardClosed');
        if (this._onWizardClosed) {
            this._onWizardClosed();
        }
    },

    addDeepCutWidget: function() {
        const root = createRoot(this.deepCutContainer$el.get(0));
        
        // Create the wizard content component (with built-in styling)
        const analysisWizardElement = React.createElement(AnalysisWizardContent, {
            results: null, // No initial results, will be loaded by the wizard
            transcript: this._transcriptText,
            transcriptId: this._transcriptId,
            projectId: this._projectId,
            onClose: this.onWizardClosed.bind(this),
            onApply: this.onEditingPlanApplied.bind(this), // Map to the editing plan callback
            isUpdating: false,
            isLoading: false,
            isEditLikeMeMode: this._isEditLikeMeMode
        });

        // Wrap with ConfigProvider that uses editor theme
        const wrappedElement = React.createElement(ConfigProvider, {
            useEditorTheme: true
        }, analysisWizardElement);

        root.render(wrappedElement);
        this._deepCutWidgetRoot = root;
    },

    onAfterPageShow: function() {
        this.addDeepCutWidget();
    },  

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    },

});

export default DeepCutPopupView; 